// keys to indentify react queries
export enum QueryKey {
  Auth = 'auth',
  FilteredProducts = 'filteredProducts',
  PrescribedProducts = 'prescribedProducts',
  CancelPrescribedProducts = 'cancelPrescribedProducts',
  FilteredProductsByDevice = 'filteredProductsByDevice',
  ProductSurvey = 'productSurvey',
  Consultation = 'consultation',
  Consultations = 'consultations',
  ConsultationBookingIssues = 'ConsultationBookingIssues',
  ConsultationNotes = 'consultationNotes',
  NurseConsultations = 'nurseConsultations',
  DoctorConsultations = 'doctorConsultations',
  GetDoctorPatientAndConsultCount = 'getDoctorPatientAndConsultCount',
  GetPrescriptions = 'getPrescriptions',
  GetConsultationStatus = 'getConsultationStatus',
  GetGenerativeScriptingPrescriptions = 'getPrescriptionsWithGenerativeScripting',
  GetOOSPrescriptions = 'getPrescriptionsWithOOSProducts',
  GetRescriptAlternatives = 'getRescriptAlternatives',
  PutPrescriptionBatchReplace = 'putPrescriptionBatchReplace',
  GetNurses = 'getNurses',
  GetDoctors = 'getDoctors',
  GetNurseFlexCalendar = 'getNurseFlexCalendar',
  ResetNurseFlexCalendar = 'resetNurseFlexCalendar',
  GetPatient = 'getPatient',
  GetPatientDetails = 'getPatientDetails',
  GetPatientAssessments = 'getPatientAssessments',
  GetPatientConsultation = 'getPatientConsultation',
  GetPatientConsultations = 'getPatientConsultations',
  PostPatientNote = 'postPatientNote',
  DeletePatientNote = 'deletePatientNote',
  GetPatientNotes = 'getPatientNotes',
  GetPatientPrescriptions = 'getPatientPrescriptions',
  GetPatientStudies = 'getPatientStudies',
  PrescribePrescription = 'prescribePrescription',
  GetMedicalConditions = 'getMedicalConditions',
  GetIhiReviewLogs = 'getIhiReviewLogs',
  GetPharmacies = 'getPharmacies',
  GetAustralianStates = 'getAustralianStates',
  GetPatientDocuments = 'getPatientDocuments',
  GetConsultationTelecomDetails = 'getConsultationTelecomDetails',
  GetPatientConcessionCard = 'getPatientConcessionCard',
  CreateConsultationPaymentRequest = 'createConsultationPaymentRequest',
  listClinics = 'listClinics',
  CreateDassAssessment = 'createDassAssessment',
  GetDassAssessment = 'getDassAssessment',
  GetDassAssessmentScores = 'getDassAssessmentScores',
  GetDassValidity = 'getDassValidity',
  UpdatePatientEmail = 'updatePatientEmail',
  SaveConsultationData = 'saveConsultationData',
  DeactivateDass = 'deactivateDass',
  DischargePatient = 'dischargePatient',
  GetDischargeReasons = 'dischargeReasons',
  PatchPatientData = 'patchPatientData',
}
